import * as Yup from 'yup';

export default Yup.object({
  license: Yup.string().required('Required'),
});
